/* eslint-disable react/jsx-key */
import React, { useContext } from "react";
import "./employeeDetail.css";
import TopBar from "../../../components/TopBarComponent/Topbar";
import BackArrow from "../../../assets/images/Icons/backArrow.svg";
import { Container, Col, Row } from "react-bootstrap";
import { EmployeeDetailContext } from "../EmployeeDetailView";
import EmpImage from "../../../assets/images/empImage.svg";
import HorizontalLine from "../../../assets/images/horizontalLine.svg";
import AlertBox from "../../../components/AlertComponent/AlertBox";
import IconProfile from "../../../assets/images/Icons/profileIcon.svg";
import { baseURL } from "../../../api/Axios";
const EmployeeDetailPage = ({ textContents }) => {
  const {
    goBack,
    employeeDetail,
    showAlert,
    setShowAlert,
    alertMessage,
    dropDownCategoryList,
    setDropDownCategoryList,
  } = useContext(EmployeeDetailContext);

  const EmpDetails = [
    {
      empName: "Manoj Kumar",
      workingUnit: "Test",
      employeeCode: "647",
      magneticCardID: "G101",
      dOb: "5-09-2023",
      email: "Manojkumar@gmail.com",
      emergencyContactNo: "9744066929",
      section: "Test",
      puchingID: "#1001",
      category: "Executive",
      contactNo: "9744066929",
    },
  ];
 // console.log("employee dob", employeeDetail?.DOB);
  const getDateLocal = () => {
    var dateToday = employeeDetail?.DOB;
    var date = dateToday ? new Date(dateToday).toLocaleDateString() : "-";
    return date;
  };

  const getEmpDeletedDate = () => {
    var dateToday = employeeDetail?.DeletedDate;
    var date = new Date(dateToday).toLocaleDateString();
    return date;
  };
  let nameCategory;
  let selectCedategoryName;
  nameCategory = dropDownCategoryList.find(
    (obj) => obj.id === employeeDetail.CategoryId
  );
  selectCedategoryName = nameCategory?.name;
  const imgPath = `${baseURL}/images/${employeeDetail.Image} `;

  return (
    <div className="employeeDetail-page">
      <TopBar />
      <Container>
        <div className="heading-row my-3">
          <div className="employeeBox" onClick={() => goBack()}>
            <img
              className="back-arrow"
              src={BackArrow}
              alt="Back Arrow"
              width={17}
            />
            <p className="employeeDetailName">{employeeDetail?.EmployeeName}</p>
          </div>
        </div>

        <div className="employeeDetailView">
          {EmpDetails.map((empDetailList) => {
            return (
              <div>
                <Row>
                  <Col md={2}>
                    <div className="employeeDetailImgDiv">
                      {employeeDetail.Image !== "" ? (
                        <img
                          className="detailempDiv"
                          src={imgPath}
                          alt="Emp Image"
                        />
                      ) : (
                        <img
                          className="defaultdetailempDiv"
                          src={IconProfile}
                          alt="Emp Image"
                        />
                      )}
                    </div>
                  </Col>
                  <Col md={5} className="employeeDetailDiv">
                    <Row>
                      <Col md={12}>
                        <Row>
                          <Col md={4} xs={4}>
                            <label className="employeeDetailLabel">
                              {textContents.employeeName}
                            </label>
                          </Col>
                          <Col md={8} xs={8}>
                            <label className="employeeDetailSemicolon">:</label>
                            <label className="employeeDetailLabel">
                              {employeeDetail?.EmployeeName}
                            </label>
                          </Col>
                        </Row>
                      </Col>
                      <img src={HorizontalLine} width={40} />
                      <Col md={12}>
                        <Row>
                          <Col md={4} xs={4}>
                            <label className="employeeDetailLabel">
                              {textContents.workingUnit}
                            </label>
                          </Col>
                          <Col md={8} xs={8}>
                            <label className="employeeDetailSemicolon">:</label>
                            <label className="employeeDetailLabel">
                              {employeeDetail?.WorkingUnit}
                            </label>
                          </Col>
                        </Row>
                      </Col>
                      <img src={HorizontalLine} width={40} />
                      <Col md={12}>
                        <Row>
                          <Col md={4} xs={4}>
                            <label className="employeeDetailLabel">
                              {textContents.employeeCode}
                            </label>
                          </Col>
                          <Col md={8} xs={8}>
                            <label className="employeeDetailSemicolon">:</label>
                            <label className="employeeDetailLabel">
                              {employeeDetail?.EmployeeCode}
                            </label>
                          </Col>
                        </Row>
                      </Col>
                      <img src={HorizontalLine} width={40} />
                      <Col md={12}>
                        <Row>
                          <Col md={4} xs={4}>
                            <label className="employeeDetailLabel">
                              {textContents.magneticCardID}
                            </label>
                          </Col>
                          <Col md={8} xs={8}>
                            <label className="employeeDetailSemicolon">:</label>
                            <label className="employeeDetailLabel">
                              {employeeDetail?.MagneticId}
                            </label>
                          </Col>
                        </Row>
                      </Col>
                      <img src={HorizontalLine} width={40} />
                      <Col md={12}>
                        <Row>
                          <Col md={4} xs={4}>
                            <label className="employeeDetailLabel">
                              {textContents.dob}
                            </label>
                          </Col>
                          <Col md={8} xs={8}>
                            <label className="employeeDetailSemicolon">:</label>
                            <label className="employeeDetailLabel">
                              {getDateLocal()}
                              {/* {employeeDetail?.DOB} */}
                            </label>
                          </Col>
                        </Row>
                      </Col>
                      <img src={HorizontalLine} width={40} />
                      <Col md={12}>
                        <Row>
                          <Col md={4} xs={4}>
                            <label className="employeeDetailLabel">
                              {textContents.email}
                            </label>
                          </Col>
                          <Col md={8} xs={8}>
                            <label className="employeeDetailSemicolon">:</label>
                            <label className="employeeDetailLabel">
                              {employeeDetail?.Email}
                            </label>
                          </Col>
                        </Row>
                      </Col>
                      <img src={HorizontalLine} width={40} />
                      <Col md={12}>
                        <Row>
                          <Col md={4} xs={4}>
                            <label className="employeeDetailLabel">
                              {textContents.supervisorContactNo}
                            </label>
                          </Col>
                          <Col md={8} xs={8}>
                            <label className="employeeDetailSemicolon">:</label>
                            <label className="employeeDetailLabel">
                              {employeeDetail?.EmergencyContact}
                            </label>
                          </Col>
                        </Row>
                      </Col>
                      <img src={HorizontalLine} width={40} />
                    </Row>
                  </Col>
                  <Col md={5} className="employeeDetailDiv">
                    <Row>
                      <Col md={12}>
                        <Row>
                          <Col md={5} xs={4}>
                            <label className="employeeDetailLabel">
                              {textContents.section}
                            </label>
                          </Col>
                          <Col md={7} xs={8}>
                            <label className="employeeDetailSemicolon">:</label>
                            <label className="employeeDetailLabel">
                              {employeeDetail?.Section}
                            </label>
                          </Col>
                        </Row>
                      </Col>
                      <img src={HorizontalLine} width={40} />
                      <Col md={12}>
                        <Row>
                          <Col md={5} xs={4}>
                            <label className="employeeDetailLabel">
                              {textContents.puchingID}
                            </label>
                          </Col>
                          <Col md={7} xs={8}>
                            <label className="employeeDetailSemicolon">:</label>
                            <label className="employeeDetailLabel">
                              {employeeDetail?.PunchingId}
                            </label>
                          </Col>
                        </Row>
                      </Col>
                      <img src={HorizontalLine} width={40} />
                      <Col md={12}>
                        <Row>
                          <Col md={5} xs={4}>
                            <label className="employeeDetailLabel">
                              {textContents.category}
                            </label>
                          </Col>
                          <Col md={7} xs={8}>
                            <label className="employeeDetailSemicolon">:</label>
                            <label className="employeeDetailLabel">
                              {selectCedategoryName}
                            </label>
                          </Col>
                        </Row>
                      </Col>
                      <img src={HorizontalLine} width={40} />
                      <Col md={12}>
                        <Row>
                          <Col md={5} xs={4}>
                            <label className="employeeDetailLabel">
                              {textContents.contactNo}
                            </label>
                          </Col>
                          <Col md={7} xs={8}>
                            <label className="employeeDetailSemicolon">:</label>
                            <label className="employeeDetailLabel">
                              {employeeDetail?.ContactNo}
                            </label>
                          </Col>
                        </Row>
                      </Col>
                      <img src={HorizontalLine} width={40} />
                      {employeeDetail?.Status == "D" && (
                        <>
                          <Col md={12} className="empInactiveUser">
                            <Row>
                              <Col md={5} xs={4}>
                                <label className="employeeDetailLabel">
                                  {textContents.status}
                                </label>
                              </Col>
                              <Col md={7} xs={8}>
                                <label className="employeeDetailSemicolon">
                                  :
                                </label>
                                <label className="employeeDetailLabel">
                                  {employeeDetail?.Status == "D"
                                    ? "Inactive"
                                    : "Active"}
                                </label>
                              </Col>
                            </Row>
                          </Col>
                          {/* <img src={HorizontalLine} width={40} /> */}
                          <Col md={12} className="empInactiveUser">
                            <Row>
                              <Col md={5} xs={4}>
                                <label className="employeeDetailLabel">
                                  {textContents.DeletedBy}
                                </label>
                              </Col>
                              <Col md={7} xs={8}>
                                <label className="employeeDetailSemicolon">
                                  :
                                </label>
                                <label className="employeeDetailLabel">
                                  {employeeDetail?.DeletedBy
                                    ? employeeDetail?.DeletedBy
                                    : "-"}
                                </label>
                              </Col>
                            </Row>
                          </Col>
                          {/* <img src={HorizontalLine} width={40} /> */}
                          <Col md={12} className="empInactiveUser">
                            <Row>
                              <Col md={5} xs={4}>
                                <label className="employeeDetailLabel">
                                  {textContents.DeletedDate}
                                </label>
                              </Col>
                              <Col md={7} xs={8}>
                                <label className="employeeDetailSemicolon">
                                  :
                                </label>
                                <label className="employeeDetailLabel">
                                  {getEmpDeletedDate()}
                                </label>
                              </Col>
                            </Row>
                          </Col>
                        </>
                      )}
                    </Row>
                  </Col>
                </Row>
              </div>
            );
          })}
        </div>
        <AlertBox
          show={showAlert}
          setShow={setShowAlert}
          alertMessage={alertMessage}
        />
      </Container>
    </div>
  );
};
export default EmployeeDetailPage;
